export default __webpack_public_path__ + "media/images/theme/m_logo_light-8680a3b5a2615db08b752c15ef00f465.png";